import { usePrivacy } from '../context/PrivacyContext';

// ── <Private> ─────────────────────────────────────────────────────────────────
// Maskiert einen personenbezogenen Wert (Betrag oder Coin-Menge), wenn der
// Privat-Modus aktiv ist. Im normalen Zustand werden die `children` 1:1
// durchgereicht (kein zusätzliches Markup). Im Privat-Modus wird der echte Wert
// NICHT gerendert, sondern durch Punkte ersetzt — so steht er weder im DOM noch
// im Screenshot.
//
//   <Private>{fmt(convert(value), locale)}</Private>
//
// `chars` überschreibt die Punkt-Anzahl (sonst aus der Länge des formatierten
// Strings abgeleitet, gedeckelt auf 3–6). `style` wird an die Punkt-Span
// durchgereicht (z. B. um Farbe/Schriftgröße der Umgebung zu erben).
export default function Private({ children, chars, style }) {
  const ctx = usePrivacy();
  if (!ctx || !ctx.privateMode) return children ?? null;

  let n = chars;
  if (!n) {
    const s = typeof children === 'string' || typeof children === 'number' ? String(children) : '';
    const visible = s.replace(/\s/g, '').length;
    n = visible ? Math.min(Math.max(visible, 3), 6) : 4;
  }

  return (
    <span aria-label="•••" style={{ letterSpacing: '0.04em', ...style }}>
      {'•'.repeat(n)}
    </span>
  );
}
